import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import React, { useEffect, useState } from "react"

const TableFilter: React.FC<{
    callBack: any
    selectedFilter?: any
    filters?: any
}> = ({
    callBack,
    selectedFilter,
    filters = [
        {
            name: "All",
            value: "all",
        },
        {
            name: "Unlock",
            value: "unlock",
        },
        {
            name: "Claim",
            value: "claim",
        },
        {
            name: "Withdraw",
            value: "withdraw",
        },
    ],
}) => {
    const [selectValue, setselectValue] = useState(
        selectedFilter ?? filters[0].value
    )
    useEffect(() => {
        setselectValue(selectedFilter ?? filters[0].value)
    }, [selectedFilter])
    return (
        <FormControl className="w-full screen500:w-48">
            <InputLabel
                id="status-select-label"
                sx={{
                    fontSize: 12,
                }}
            >
                Status
            </InputLabel>
            <Select
                labelId="status-select-label"
                label="Status"
                sx={{
                    ".MuiOutlinedInput-input": {
                        padding: "10px",
                        fontSize: 12,
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                    },
                }}
                value={selectValue}
                onChange={(e) => {
                    const val = e.target.value
                    setselectValue(val)
                    callBack(val)
                }}
            >
                {filters?.map((item: any, index: number) => (
                    <MenuItem
                        key={index}
                        value={item.value}
                        sx={{ fontSize: 12 }}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default TableFilter
